import { FunctionalComponent, h } from '@stencil/core';
import { IIconProps } from './interfaces';

const Warning: FunctionalComponent<IIconProps> = ({ width = '24', height = '24', fill = '#333' }) => {
  return (
    /*@ts-ignore*/
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.8118 3.47494L12.8743 3.57362L21.1748 18.5145C21.2573 18.6631 21.3006 18.8302 21.3006 19.0001C21.3006 19.513 20.9146 19.9356 20.4172 19.9934L20.3006 20.0001H3.69964C3.5297 20.0001 3.36256 19.9568 3.214 19.8743C2.7657 19.6252 2.5837 19.0825 2.77473 18.6197L2.82549 18.5145L11.126 3.57362C11.2167 3.41038 11.3512 3.2758 11.5145 3.18511C11.9628 2.93605 12.5197 3.06824 12.8118 3.47494ZM12.0002 11.5003C11.4479 11.5003 11.0002 11.948 11.0002 12.5003V16.5003C11.0002 17.0526 11.4479 17.5003 12.0002 17.5003C12.5524 17.5003 13.0002 17.0526 13.0002 16.5003V12.5003C13.0002 11.948 12.5524 11.5003 12.0002 11.5003ZM12.0002 8.00019C11.4479 8.00019 11.0002 8.4479 11.0002 9.00019C11.0002 9.55247 11.4479 10.0002 12.0002 10.0002C12.5524 10.0002 13.0002 9.55247 13.0002 9.00019C13.0002 8.4479 12.5524 8.00019 12.0002 8.00019Z"
        fill={fill}
      />
    </svg>
  );
};

export default Warning;
